import { supabaseRpc } from '@/lib/supabaseClient'

export function syncCurrentUserEmail(email: string) {
  return supabaseRpc('update_current_user_email', { p_email: email })
}
